/* eslint-disable no-nested-ternary */
/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';
import { getIconPath } from '@tcp/core/src/utils';

export default css`
  position: relative;
  padding-top: 32px;
  background-color: ${(props) =>
    props.isFooterRedesignEnabled ? props.theme.colors.PALEGRAY : props.theme.colors.WHITE};

  #userAgeEmail {
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
  }
  #userAgeSms {
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
  }
  .marginBottom {
    margin-bottom: 60px;
  }

  .content-wrapper-new {
    max-width: none;
    margin: unset;
  }

  .marginBottomStickyHeader {
    margin-bottom: 83px;
  }

  > .footer-candidate-wrapper {
    .content-wrapper {
      margin: 0 auto;
      padding-bottom: 0;
      @media ${(props) => props.theme.mediaQuery.mediumMax} {
        ${(props) =>
          props.isFooterRedesignEnabled &&
          `
             width: 100%;
             gap:24px;
          `}
      }
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      border-bottom: 1px solid ${(props) => props.theme.colors.PRIMARY.LIGHTGRAY};
      .content-wrapper {
        padding-bottom: 24px;
        width: 100%;
      }
    }
  }

  .footer_top_candidate_a .flex-align-center {
    ${(props) =>
      props.isFooterRedesignEnabled ? `justify-content: space-between;` : ` align-items: center;`}
  }
  .footer_top_candidate_a .candidate_a_inline_container_button {
    text-align: center;
  }
  .footer-legel-links {
    @media ${(props) => props.theme.mediaQuery.large} {
      justify-content: center;
      flex-wrap: wrap;
    }
  }
  .footer-bottom-redesign .footer-legel-links {
    @media ${(props) => props.theme.mediaQuery.large} {
      padding-top: 20px;
    }
  }

  .footer_top_candidate_a .new-candA-cls {
    flex-direction: column;
    width: 100%;
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      margin-left: 0;
      margin-right: 0;
    }
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    .footer_top_candidate_a .new-candA-cls {
      gap: 20px; /* General gap for all children */
    }

    .footer_top_candidate_a .new-candA-cls > :first-child {
      margin-bottom: -8px; /* Specific gap after the first child */
    }
  }
  .footer_top_candidate_a .email-sign-up,
  .footer_top_candidate_a .sms_sign_up {
    ${(props) =>
      !props.isFooterRedesignEnabled &&
      `
     font-size: 12px;
    line-height: 2.08;
    `}
  }
  .footer_top_candidate_a .new-candA-cls .email-sign-up,
  .footer_top_candidate_a .new-candA-cls .sms_sign_up {
    text-align: left;
    margin-top: 0;
  }
  .footer_top_candidate_a .new-candA-cls .sms_sign_up:after {
    padding: 12px 0;
    color: #000;
    font-family: Nunito;
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
  }
  .footer_top_candidate_a .new-candA-cls .disclaimer,
  .footer_top_candidate_a .new-candA-cls .disclaimer1 {
    color: #000;
    font-family: Nunito;
    font-size: 8px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 12px */
    text-align: left;
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      color: #000;
      font-family: Nunito;
      font-size: 9px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%; /* 13.5px */
    }
  }
  .footer_top_candidate_a .new-candA-cls .offer-zone {
    color: #000;
    font-family: Nunito;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 18px */
    letter-spacing: 0.12px;
    text-transform: capitalize;
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      background-color: #fafafa;
      border-bottom: 1px solid #e3e3e3;
      padding: 0;
    }
  }
  .footer_top_candidate_a .new-candA-cls .email_sign_up_helper_text {
    font-size: 16px;
    color: #003057;
    font-weight: 800;
    font-family: Nunito;
    font-style: normal;
    line-height: 150%; /* 18px */
    text-transform: capitalize;

    @media ${(props) => props.theme.mediaQuery.smallMax} {
      font-size: 14px;
    }
  }
  .footer-wrapper {
    display: flex;
    flex-direction: row-reverse;
    width: 100%;
    padding: 32px;
    background-color: #fafafa;
    box-sizing: border-box; /* Ensures padding is included within the width */
    overflow: hidden; /* Prevents child elements from causing overflow */
    max-width: 100vw; /* Ensures the maximum width does not exceed the viewport */
    margin-top: 24px;
    padding-bottom: 12px;
  }

  .footer-middle-cls {
    flex: 6;
  }
  .footer-top-cls {
    flex: 4;
  }

  .navLinksWrapper {
    display: flex;
    width: 100%;
    @media ${(props) => props.theme.mediaQuery.large} {
      align-items: flex-start;
    }
  }

  .navLinksChild {
    flex: 1;
  }
  .navLinksChild > * {
    background-color: ${(props) => props.theme.colors.PALEGRAY};
  }

  .footer_top_candidate_a .new-candA-cls .TextBox__input,
  .footer_top_candidate_a .new-candA-cls .input-fields-wrapper {
    margin-bottom: 0;
    margin-top: 12px;
  }
  .footer_top_candidate_a .new-candA-cls .TextBox__input {
    margin-top: 0;
    border-radius: 6px;
    border: 1px solid #d8d8d8;
    padding-top: 12px;
    padding-bottom: 12px;
    padding-left: 16px;
    font-size: 13px;
    background: #fff;
    width: 97%;
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      padding-left: 2px;
      padding-bottom: 11px;
      padding-top: 11px;
    }
  }
  .footer_top_candidate_a .new-candA-cls .TextBox__label {
    padding-left: 2px;

    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      padding-left: 2px;
    }
  }

  .footer_top_candidate_a .new-candA-cls .TextBox__input:focus ~ .TextBox__label,
  .footer_top_candidate_a .new-candA-cls .TextBox__input:focus-visible ~ .TextBox__label {
    display: none;
  }

  .footer_top_candidate_a
    .new-candA-cls
    .TextBox__input:not(:focus):not(:placeholder-shown)
    ~ .TextBox__label {
    display: none;
  }

  .footer_top_candidate_a .new-candA-cls .TextBox__placeholder {
    top: 12px;
    left: 10px;
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      top: 10px;
    }
  }
  .footer_top_candidate_a .new-candA-cls .refer_a_friend_button {
    border-radius: 6px;
    background: #000;
    color: #fff;
    font-family: Nunito;
    font-size: 11px;
    font-style: normal;
    font-weight: 800;
    line-height: normal;
    letter-spacing: 0.055px;
    text-transform: capitalize;
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      padding: 10px;
    }
  }

  .candidate_a_inline_container_button button {
    white-space: normal;
    font-size: ${(props) => props.theme.typography.fontSizes.fs13};
    min-height: 42px;

    a {
      text-decoration: none;
      color: ${(props) =>
        props.isFooterRedesignEnabled ? `#fff;` : props.theme.colors.TEXT.DARKERGRAY};
    }
    &.candidate_a_form_button {
      width: 100%;
      ${(props) =>
        props.theme.gridDimensions.gridBreakPointsKeys.map((key) =>
          ['small', 'medium'].includes(key)
            ? `
          @media ${props.theme.mediaQuery[`${key}Only`]} {
            padding: 0;
            margin-top: 10px;
          }`
            : `${
                props.isFooterRedesignEnabled
                  ? `border-radius: 6px;
                      background: #000;
                      color: #fff;
                      height:36px;
                      font-family: Nunito;
                      font-size: 11px;
                      font-style: normal;
                      font-weight: 800;
                      line-height: normal;
                      letter-spacing: 0.055px;
                      text-transform: capitalize;`
                  : `padding: 0;
            margin-top: 10px;`
              }

            `
        )}
    }
  }
  .candidate-b_buttons {
    padding: 11px 0 0 0;
  }

  .social_media_wrapper {
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-top: 44px;
    }
  }

  .heading_text {
    margin-bottom: 15px;
    text-align: center;
    .style2 {
      color: ${(props) => props.theme.colorPalette.primary.main};
    }
  }

  .footer_top_candidate_a .heading_text {
    margin-bottom: 0;
    margin-top: 10px;
    text-align: center;
    color: ${(props) => props.theme.brandSpecificStyles.FOOTER.FOOTER_TOP_CANDIDATE_COLOR};
  }
  .footer_top_candidate_a .refer-a-friend {
    margin-bottom: 12px;
  }

  .footer_top_candidate_a .new-candA-cls .refer-a-friend {
    text-align: left;
    margin-top: 0;
  }
  .candidate-b_buttons .heading_text {
    font-size: 10px;
    padding-top: 3px;
  }

  .footer_top_candidate_a .divider {
    height: 1px;
    background-color: ${(props) => props.theme.colors.PRIMARY.LIGHTGRAY};
    margin-top: 43px;
    margin-bottom: 24px;
    width: 100%;
  }
  .footer-candidate-wrapper .divider {
    height: 1px;
    background-color: ${(props) => props.theme.colors.PRIMARY.LIGHTGRAY};
    width: 100%;
  }

  .footer_top__signup_form {
    margin-bottom: 24px;
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-bottom: 16px;
    }

    label {
      margin-bottom: 10px;
    }
    .footer_top__signup_form_row {
      align-items: normal;
      @media ${(props) => props.theme.mediaQuery.large} {
        ${(props) =>
          props.isFooterRedesignEnabled &&
          `align-items: baseline;
          justify-content: space-between;
           > :first-child {
        width: 72%;
      }

      > :nth-child(2) {
        width: 25%;
      }
          `}
      }
    }

    .CheckBox__text {
      margin-top: 6px;
      font-size: 14px;
    }
  }

  .footer_top_candidate_a .new-candA-cls .footer_top__signup_form {
    margin-bottom: 12px;
  }

  .poc-hide {
    display: none;
  }

  .footer-top__slots {
    padding-bottom: 16px;
  }
  .footer-top__slot-2 {
    order: 1;
  }
  .footer-bottom__slot--1 {
    background-color: ${(props) => props.theme.colorPalette.primary.main};
  }
  .fullbleed-mobile {
    flex-direction: column-reverse;
    display: flex;
    margin: 0;
  }
  .default-offset {
    padding: 0 ${(props) => props.theme.gridDimensions.gridOffsetObj.small}px;
  }
  .footer-middle.desktop {
    display: none;
  }
  .reference-id {
    background-color: ${(props) => props.theme.colorPalette.primary.main};
    font-size: ${(props) => props.theme.fonts.fontSize.body.small.tertiary}px;
    padding: 0 15px 24px;
    margin: 0;
    color: ${(props) => props.theme.colors.WHITE};
    font-family: ${(props) => props.theme.secondaryFontFamily};
    margin-top: -5px;
  }

  .footer_top_candidate_a_social_links {
    display: flex;
    flex-direction: ${(props) =>
      props.theme.brandSpecificStyles.FOOTER
        .FOOTER_TOP_CANDIDATE_A_SOCIAL_LINKS_FLEX_DIRECTION_MOBILE};
    align-items: center;
    justify-content: flex-start;

    .social-media-label {
      margin-right: 22px;
      @media ${(props) => props.theme.mediaQuery.medium} {
        margin-right: 26px;
      }
      font-family: ${(props) => props.theme.fonts.tertiaryUrbaneBold};
      font-size: 16px;
      font-weight: bold;
      color: ${(props) => props.theme.colors.TEXT.DARKGRAY};
    }

    @media ${(props) => props.theme.mediaQuery.large} {
      ${(props) => `
      flex-direction: ${props.theme.brandSpecificStyles.FOOTER.FOOTER_TOP_CANDIDATE_A_SOCIAL_LINKS_FLEX_DIRECTION};
      .social-media-label {
       margin: ${props.theme.brandSpecificStyles.FOOTER_TOP_CANDIDATE_SOCIAL_MARGIN};
       }
      `}
    }
  }
  .refer_a_frient_last_colm {
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      margin-left: 4%;
      width: inherit;
    }
  }

  #userAgeReferFrnd {
    padding-top: 21px;
  }

  &.navigation-footer {
    .footer-top,
    .footer_top_candidate_a {
      > div {
        ${(props) =>
          !props.isNavigationFooter
            ? `
            border: 1px solid ${props.theme.colors.PRIMARY.LIGHTGRAY};

          `
            : ''};
        ${(props) => (props.isFooterRedesignEnabled ? 'padding-top: 0;' : 'padding-top: 32px;')}
      }

      .refer-a-friend {
        margin-bottom: 12px;
        font-size: 15px;
      }
    }
    .reference-id {
      ${(props) => !props.isFooterRedesignEnabled && ' display: none;'}
    }
    .social-media-label {
      margin-right: 0;
      padding: 8px 0;
    }
    .social-media-links {
      font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy4};
      flex-direction: column;
      padding: 0;
    }
    .email-sign-up-form button,
    .footer_top__signup_form button {
      padding: 0;
      @media ${(props) => props.theme.mediaQuery.mediumMax} {
        ${(props) =>
          props.isFooterRedesignEnabled &&
          `
         border-radius: 6px;
        background-color: #000;
        color: #FFF;
        font-family: Nunito;
        font-size: 10px;
        font-style: normal;
        font-weight: 800;
        line-height: normal;
        letter-spacing: 0.05px;
        `}
      }
    }

    .footer-bottom__slot--1 {
      width: 100%;

      > div {
        ${(props) =>
          props.isFooterRedesignEnabled ? ' padding: 20px 0 2px;' : ' padding: 24px 0;'}
      }
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      .refer_a_friend_desktop .candidate_a_inline_container_button button {
        width: auto;
      }
      .footer_top_candidate_a .candidate_a_inline_container_button {
        text-align: center;
      }
    }
  }

  .footer-bottom {
    > .content-wrapper {
      @media ${(props) => props.theme.mediaQuery.small} and ${(props) =>
          props.theme.mediaQuery.mediumMax} {
        margin: 0;
        width: 100%;
      }
    }
  }

  @media ${(props) => props.theme.mediaQuery.medium} {
    .default-offset {
      padding: 0 ${(props) => props.theme.gridDimensions.gridOffsetObj.medium}px;
    }
    .hide-in-medium-up {
      display: none;
    }
    .footer_top_candidate_a .heading_text.refer_friend_text {
      margin-bottom: 0;
    }
    .footer_top_candidate_a .refer-a-friend {
      font-size: 12px;
      line-height: 1.67;
      margin-bottom: 0;
      margin-top: 0;
    }
    &.navigation-footer .col-md-half-width {
      width: 100%;
      margin-right: 0;
    }
    &.navigation-footer .hide-in-medium-up {
      display: block;
    }
    .footer_top_candidate_a .candidate_a_inline_container_button {
      text-align: right;
    }
  }
  .language-name span {
    ${(props) => props.isFooterRedesignEnabled && `border-bottom: 1px solid #e3e3e3 !important;`}
  }

  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    .footer-bottom-redesign .footer-bottom__slot--2 {
      display: none;
    }
    .footer-bottom-redesign .footer-bottom__slot--1 {
      background-color: #fafafa;
    }
    .footer-middle .container-accordion {
      ${(props) => props.isFooterRedesignEnabled && 'padding-top:0;'}
    }
    .footer-middle .container-accordion .item-active {
      ${(props) => props.isFooterRedesignEnabled && `border-bottom:1px solid #e3e3e3;`}
      ${(props) =>
        props.isFooterRedesignEnabled &&
        props.isNavigationFooter &&
        `padding-bottom: 12px; background-color: #fafafa;`}
    }
    .footer-middle .container-accordion .item-active p {
      ${(props) => props.isFooterRedesignEnabled && `border-bottom:0;`}
    }
    .footer-top-cls {
      background-color: #fafafa;
      margin: 0;
      min-height: 34px;
      padding: 18px 12px 0;
      border-bottom: 1px solid #e3e3e3;
      .divider {
        display: none;
      }
    }

    .footer-top-cls > :first-child {
      display: none;
    }

    .new-top-cand {
      margin-right: auto;
      margin-left: 0;
      gap: 24px;
    }
    .offer-zone {
      margin-left: 0;
      width: 100%;
      color: #000;
      font-family: Nunito;
      font-size: 12px;
      font-style: normal;
      font-weight: 600;
      line-height: 150%; /* 18px */
      letter-spacing: 0.12px;
      text-transform: capitalize;
      margin-right: 0;
      align-items: end;
    }
    .closed {
      background-image: ${(props) => `url(${getIconPath('down_arrow_icon', props)})`};
      background-repeat: no-repeat;
      display: inline-block;
      right: 15px;
      position: absolute;
      font-weight: bold;
      font-size: 20px;
      color: ${(props) => props.theme.colors.ACCORDION.COLLAPSE_EXPAND_ICON};
      height: 10px;
      width: 10px;
    }
    .open {
      background-image: ${(props) => `url(${getIconPath('up_arrow_icon', props)})`};
      background-repeat: no-repeat;
      display: inline-block;
      right: 15px;
      position: absolute;
      font-weight: bold;
      font-size: 20px;
      color: ${(props) => props.theme.colors.ACCORDION.COLLAPSE_EXPAND_ICON};
      height: 10px;
      width: 10px;
    }

    .refer-a-friend-new {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 16px;
      margin-top: 24px;
    }
    .refer-a-friend-new .new-cls {
      color: #fff;
      font-family: Nunito;
      font-size: 10px;
      font-style: normal;
      font-weight: 800;
      line-height: normal;
      letter-spacing: 0.05px;
    }
    .footer_top_candidate_a .candidate_a_inline_container_button {
      ${(props) =>
        props.isFooterRedesignEnabled &&
        `
          text-align: right;
      width: 60%;
        `}
    }
    .footer_top_candidate_a .footer_top__signup_form_row {
      ${(props) =>
        props.isFooterRedesignEnabled &&
        `
          flex-wrap: nowrap;
          justify-content: space-between;
          `}
    }
    .footer_top_candidate_a .footer_top__signup_form_row .candidate_a_inline_container_button {
      ${(props) =>
        props.isFooterRedesignEnabled &&
        `
          width: 40%;
          `}
    }
  }

  @media ${(props) => props.theme.mediaQuery.smallMax} {
    ${(props) =>
      props.isFooterRedesignEnabled &&
      `
    .sms_body_text_off:before {
      content: ' ';
    }

    .footer_top_candidate_a .candidate_a_inline_container_button {
      width: 37%;
    }
    .footer_top_candidate_a .footer_top__signup_form_row .candidate_a_inline_container_button {
      width: 25%;
    }
    .footer_top_candidate_a .new-candA-cls .TextBox__input {
      width: 105%;
    }
    `}
  }

  @media ${(props) => props.theme.mediaQuery.large} {
    padding-top: ${(props) => (props.isFooterRedesignEnabled ? '0' : '64px')};
    .hide-in-large-up {
      display: none;
    }
    .footer-top {
      padding-bottom: 44px;
      border-bottom: 1px solid ${(props) => props.theme.colors.PRIMARY.LIGHTGRAY};
    }
    .candidate-b_buttons {
      padding: 11px 38px 0 38px;
    }
    .candidate-b_buttons .heading_text {
      font-size: 15px;
    }
    .footer-bottom {
      background-color: ${(props) => props.theme.colors.PRIMARY.PALEGRAY};
    }
    .reference-id {
      text-align: center;
      background-color: ${(props) => props.theme.colors.PRIMARY.PALEGRAY};
      font-size: ${(props) => props.theme.fonts.fontSize.body.small.secondary}px;
      padding: 11px 0 24px;
      color: ${(props) => props.theme.colors.TEXT.DARKERGRAY};
    }
    .footer-bottom-redesign,
    .footer-bottom-redesign .reference-id {
      background-color: ${(props) => props.theme.colors.WHITE};
    }
    .footer-top-cls .reference-id {
      color: #595959;
      text-align: right;
      font-family: Nunito;
      font-size: 10px;
      font-style: normal;
      font-weight: 500;
      line-height: 150%;
      background-color: unset;
      width: 100%;
    }
    .new-candA-cls .hide-in-medium-down {
      display: none;
    }
    .app-promo-new-cls {
      display: none;
    }

    .fullbleed-mobile {
      flex-direction: row;
      margin: 0 ${(props) => props.theme.gridDimensions.gridOffsetObj.medium}px;
    }
    .default-offset {
      padding: 0;
    }
    .footer-bottom__slot--1 {
      background-color: inherit;
    }
    .footer-middle.mobile {
      display: none;
    }
    .footer-middle.desktop {
      display: flex;
      ${(props) => !props.isFooterRedesignEnabled && `padding: 36px 0 64px;`}
    }
    .divider {
      border-left: 1px solid ${(props) => props.theme.colors.FOOTER.DIVIDER};
    }

    .refer_a_friend_desktop {
      margin-right: 0;
    }
    .footer_top_candidate_a .email-sign-up,
    .footer_top_candidate_a .sms_sign_up,
    .footer_top_candidate_a .refer-a-friend {
      font-size: 15px;
      line-height: 1.67;
    }
    .footer_top_candidate_a .sms_sign_up {
      font-size: 12px;
      line-height: 2.08;
    }

    .footer_top_candidate_a .refer-a-friend {
      margin-top: 0;
    }

    .candidate_a_inline_container_button .refer_a_friend_button {
      width: 165px;
      padding: 0px;
      @media ${(props) => props.theme.mediaQuery.smallMax} {
        width: 192px;
      }
    }
    .footer_top_candidate_a .refer_a_friend_spacer {
      ${(props) => (props.isReferFriendDisabled ? 'height: 42px;' : '')}
    }
  }

  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    .candidate_a_inline_container_button button {
      padding: 12px 20px;
      width: 100%;
    }
  }

  .checkout-pages .footer-global & {
    display: none;
  }
  .confirmation-pages .footer-global & {
    display: none;
  }

  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    .hide-in-medium-down {
      display: none;
    }
    .footer-bottom-redesign .reference-id {
      color: #595959;

      font-family: Nunito;
      font-size: 9px;
      font-style: normal;
      font-weight: 500;
      line-height: 150%; /* 13.5px */
      background: #fafafa;
      padding-top: 8px;
    }
  }

  @media ${(props) => props.theme.mediaQuery.desktop} {
    .content-wrapper {
      max-width: ${(props) =>
        props.isPdpPage && props.isRedesignedPdpDesktopView
          ? '100%'
          : props.theme.breakpoints.maxWidth};
    }
    .fullbleed-mobile {
      margin-right: ${(props) =>
        props.isPdpPage && props.isRedesignedPdpDesktopView ? '140px' : '15px'};
    }
    .footer-middle.desktop {
      padding: ${(props) =>
        props.isPdpPage && props.isRedesignedPdpDesktopView ? '36px 20px 64px' : '36px 0 64px'};
    }
    .footer_top_candidate_a {
      padding: ${(props) =>
        props.isPdpPage && props.isRedesignedPdpDesktopView
          ? '0px 20px 24px 20px;'
          : '0px 0px 24px 0px'};
    }
  }
  .refer-a-friend-alignment {
    @media ${(props) => props.theme.mediaQuery.large} {
      ${(props) => `display: ${props.theme.isGymboree ? 'contents' : 'inline-block'}`};
    }
  }
`;

export const FooterSkeletonCandidateA = styled.div`
  @media (min-width: 1920px) {
    height: 220px;
  }
  @media (min-width: 1364px) and (max-width: 1919px) {
    height: 247.72px;
  }
  @media (min-width: 1200px) and (max-width: 1363px) {
    height: 261px;
  }
  .footer-skeleton {
    height: 100%;
  }
  .footer-item {
    @media (min-width: 1200px) {
      height: 100%;
    }
    @media (min-width: 1000px) and (max-width: 1199px) {
      height: 232px;
    }
    @media (min-width: 768px) and (max-width: 999px) {
      height: 268px;
    }
  }
  .footer-item-refer {
    @media (min-width: 1200px) {
      height: 100%;
    }
    @media (min-width: 1100px) and (max-width: 1199px) {
      height: 108px;
    }
    @media (min-width: 768px) and (max-width: 1099px) {
      height: 118px;
    }
    @media (max-width: 767px) {
      height: 86px;
    }
  }
  .footer-item-download {
    @media (max-width: 767px) {
      height: 195px;
    }
  }
  .footer-login {
    @media (min-width: 400px) and (max-width: 767px) {
      height: 300px;
    }
    @media (max-width: 399px) {
      height: 326px;
    }
  }
  .loading-item {
    @media (min-width: 400px) and (max-width: 767px) {
      height: 232px;
    }
    @media (max-width: 399px) {
      height: 258px;
    }
  }
  .footer-text-alert {
    @media (min-width: 500px) and (max-width: 767px) {
      height: 250px;
    }
    @media (max-width: 499px) {
      height: 310px;
    }
  }
`;
export const FooterSkeletonBottomView = styled.div`
  .skeleton-middle-section {
    padding-top: 32px;
    @media ${(props) => props.theme.mediaQuery.large} {
      height: 617px;
    }
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      height: 292px;
    }
  }
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    margin-bottom: 60px;
  }
  .skeleton-copyright {
    padding-top: 32px;
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-top: 100px;
      height: 121px;
    }
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      margin-top: 29px;
      height: 500px;
    }
  }
  .new-skeleton-middle-section {
    @media ${(props) => props.theme.mediaQuery.large} {
      height: 530.5px;
      margin-left: calc(-48px); /* Overlap left margin */
      margin-right: calc(-48px); /* Overlap right margin */
      margin-bottom: 49.5px;
      position: relative;
    }
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      height: 475px;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      height: 395.5px;
      margin-bottom: 81.5px;
    }
  }
`;

export const StyledFooterWrapper = styled.div`
  @media ${(props) => props.theme.mediaQuery.desktop} {
    width: ${(props) => (props.isNewPdpSideBar ? 'calc(100% - 186px)' : '')};
  }

  @media ${(props) => props.theme.mediaQuery.large} {
    .footer_top_candidate_a {
      ${(props) => !props.isFooterRedesignEnabled && `margin:  auto;`}
    }
  }
`;
